/* global BigInt */
import { useEffect, useState } from "react";
export const LIVE_LIMIT_MS = 120000;
// Mirror contract integer math, anchored to chain time and monotonic elapsed time.
// This is display-only; the contract remains authoritative for claims and ownership.
export function estimateVesting(row, timestamp, elapsedMs) {
  if (timestamp === undefined || row.start === undefined) return row;
  const now = BigInt(timestamp) + BigInt(Math.floor(Math.max(0, Math.min(LIVE_LIMIT_MS, elapsedMs)) / 1000));
  const start = BigInt(row.start), end = BigInt(row.end), allocation = BigInt(row.allocation), claimed = BigInt(row.claimed);
  const vested = now >= end ? allocation : now <= start ? 0n : allocation * (now - start) / (end - start);
  return { ...row, vested, claimableNow: vested > claimed ? vested - claimed : 0n, unvested: allocation - vested, matured: now >= end };
}
export function useLiveVesting(snapshot) {
  const [now, setNow] = useState(() => performance.now());
  useEffect(() => {
    const tick = () => setNow(performance.now());
    const timer = setInterval(tick, 250);
    document.addEventListener("visibilitychange", tick);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", tick); };
  }, []);
  const elapsed = snapshot.receivedAt === undefined ? 0 : Math.max(0, now - snapshot.receivedAt);
  return { rows: snapshot.rows.map(row => estimateVesting(row, snapshot.timestamp, elapsed)), stale: elapsed >= LIVE_LIMIT_MS };
}
